import { plainToClass } from "class-transformer";
import { DeliverableChildExtended, DeliverableParentExtended, DeliverablesAttachmentsConfig, DeliverableComment } from "./deliverables-tracker.objects";
import { JsonItem, PickListItem } from "../../list-management/scripts/list-management.objects";
import { getDisplayDate } from "../../../shared/scripts/date-functions";
import { DocumentInfoV2 } from "../../../shared/components/document-tree/document-tree.objects"

export class EditDeliverablesAttachmentsController {
    // Config
    modalId: string;
    getAttachmentsRoute: string; 
    addAttachmentsRoute: string; 
    removeAttachmentsRoute: string


    // Variables
    currentChild: DeliverableChildExtended;
    currentDocuments: DocumentInfoV2[];

    filesToUpload: File[];
    constructor(config: DeliverablesAttachmentsConfig) {
        this.modalId = config.modalIdTarget;
        this.getAttachmentsRoute = config.getAttachmentsRoute;
        this.addAttachmentsRoute = config.addAttachmentsRoute;
        this.removeAttachmentsRoute = config.removeAttachmentsRoute;
    }

    async initialize(currentItem: any) {
        this.showLoading(true);

        this.filesToUpload = [];

        this.currentDocuments = [];
        this.currentChild = undefined;

        this.currentChild = <DeliverableChildExtended>currentItem;

        let result = await this.getDocumentsChild(this.currentChild);
        if (result["items"]) {
            this.currentDocuments = JSON.parse(result["items"]);
        }

        this.generateHtml();

        this.showLoading(false);
    }

    // After adding a new comment
    async updateDocuments() {
        this.currentDocuments = [];
        this.filesToUpload = [];
        let result = await this.getDocumentsChild(this.currentChild);
        if (result["items"]) {
            this.currentDocuments = JSON.parse(result["items"]);
        }
        this.updateDocumentHtml();
    }

    async getDocumentsChild(child: DeliverableChildExtended) {
        let result: any;
        try {
            result = await $.ajax(this.getAttachmentsRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(child) }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    updateDocumentHtml(): void {
        // Update file gallery (empty)
        this.drawGallery();

        // Update Added Attachments
        let addedAttachmentsCount = $(`#${this.modalId}`).find("#added-attachments-count");
        addedAttachmentsCount.text(this.currentDocuments.length);

        let addedAttachmentsTable = $(`#${this.modalId}`).find("#added-attachments-table");
        let updatedAttachmentsTable = this.createDocumentTable();
        addedAttachmentsTable.empty().html(updatedAttachmentsTable);
        this.initializeCurrentDocTable();
    }

    createDocumentTable(): string {
        // Create List of currently stored documents
        let addedAttachmentsContent = "";

        if (this.currentDocuments.length == 0) {
            return `<div class="font-weight-500">No Current Attachments</div>`
        }

        for (let i = 0; i < this.currentDocuments.length; i++) {
            let document = this.currentDocuments[i];
            let documentContent = `
                <div class="card">
                    <div class="card-header" id="added-attachment-${i}">
                        <div class="row justify-content-between">
                            <div class="col">
                                <div class="header-text">
                                    <a class="text-decoration-none d-flex align-items-center">
                                        <span class="expand-text d-block pl-2">${document.text}</span>
                                    </a>
                                </div>
                            </div>
                            <div class="col-auto pr-4">
                                <a data-toggle="collapse" data-target="#confirm-delete-attachment-${i}" aria-expanded="false" class="text-decoration-none add-attachment-expand">
                                    <div class="added-attachment-delete-icon">
                                        <i class="fa-solid fa-trash"></i>
                                    </div>
                                    <div class="added-attachment-cancel-icon">
                                        <i class="fa-solid fa-xmark fa-lg"></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div id="confirm-delete-attachment-${i}" class="collapse">
                        <div class="px-3 pb-2 d-flex align-items-center">
                            <div>
                                <button class="redbtn btn btn-sm delete-attachment-btn" type="button" data-id="${i}">Delete Attachment</button>
                            </div>
                            <div class="px-3">
                                <button class="greybtn btn btn-sm" type="button" data-toggle="collapse" data-target="#confirm-delete-attachment-${i}">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            addedAttachmentsContent += documentContent;
        }

        return addedAttachmentsContent;
    }

    generateHtml(): void {

        let description = "";
        if (this.currentChild) {
            description = `<p class="font-italic">${this.currentChild.DeliverableChild.Description}</p>`;
        }

        let addedAttachmentsContent = this.createDocumentTable();

        let html = `
            <div class="col-12 mb-3">
                <div class="modal-title">Edit Attachments</div>
                ${description}
            </div>
            <div class="col-12 mb-3">
                <p><b>NOTE</b>: Any uploaded attachments will be visible to: (1) individuals within your center, (2) the CDSC and (3) NIH/NIAID</p>
            </div>
            <div class="col-12">
                <div id="edit-attachments-block" class="row">
                    <div class="col-md-6 col-12 mb-4">
                        <div class="edit-attachments-label mb-2">Upload Attachments</div>
                        <div id="file-upload-block" class="file-upload-block p-3">
                            <div class="text-center">
                                <i class="fas fa-cloud-upload-alt fa-2x"></i>
                            </div>
                            <p class="text-center">Drag and Drop Files Here!</p>

                            <input id="file-upload-input" class="position-absolute file-upload-input invisible" type="file" multiple/>

                            <div class="text-center mb-3">
                                <label class="btn btn-small revampp-white-btn choose-file-btn" for="file-upload-input">Choose Files <i class="fa-solid fa-file pl-1"></i></label>
                            </div>

                            <div class="file-upload-gallery deliverable-collapse-table">
                                
                            </div>
                        </div>
                        <div id="file-upload-btn-container" class="d-none mt-3">
                            <button class="greenbtn btn btn-sm" type="button" id="file-upload-btn">Upload Files <span id="file-upload-btn-count" class="number-pill">0</span></button>
                        </div>
                    </div>
                    <div class="col-md-6 col-12 mb-4">
                        <div class="edit-attachments-label mb-2">Added Attachments: <span id="added-attachments-count">${this.currentDocuments.length}</span></div>
                        <div class="deliverable-collapse-table" id="added-attachments-table">
                            ${addedAttachmentsContent}
                        </div>
                    </div>
                </div>
                <div id="saving-attachments-container" class="d-none py-5">
                    <div class="text-center pb-2 font-size16 font-weight-500">Updating Attachments</div>
                    <div class="text-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>           
        `

        $(`#${this.modalId}`).find(".edit-attachments-container").empty().html(html);

        this.initializeAttachments();
    }

    initializeAttachments(): void {
        // disable default behavior for upload blocks
        let uploadBlock = $(`#${this.modalId}`).find("#file-upload-block");

        uploadBlock.on("dragenter dragover dragleave drop", (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        // disable default behavior for modal
        $(`#${this.modalId}`).on("dragenter dragover dragleave drop", (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        uploadBlock.on("dragenter dragover", (e) => {
            uploadBlock.addClass("highlight-upload-block");
        })

        uploadBlock.on("dragleave drop", (e) => {
            uploadBlock.removeClass("highlight-upload-block");
        })

        uploadBlock.on("drop", (e) => {

            let uploadedFiles = e.originalEvent.dataTransfer.files;

            if (uploadedFiles.length <= 0) {
                return;
            }

            for (let i = 0; i < uploadedFiles.length; i++) {
                this.filesToUpload.push(uploadedFiles[i])
            }

            this.drawGallery();
        })

        let uploadInput = $(`#${this.modalId}`).find("#file-upload-input");
        uploadInput.on("change", (e) => {
            let uploadedFiles: File[] = uploadInput.prop("files");

            if (uploadedFiles.length <= 0) {
                return;
            }

            for (let i = 0; i < uploadedFiles.length; i++) {
                this.filesToUpload.push(uploadedFiles[i])
            }

            this.drawGallery();
        });

        let uploadFilesBtn = $(`#${this.modalId}`).find("#file-upload-btn");
        uploadFilesBtn.on("click", async () => {
            if (this.filesToUpload.length == 0) return;
            this.showSaving(true);
            await this.uploadAttachments();
            await this.updateDocuments();
            this.showSaving(false);

        });

        this.initializeCurrentDocTable()
    }

    initializeCurrentDocTable(): void {
        $(`#${this.modalId}`).find(".delete-attachment-btn").on("click", async (e) => {
            let button = $(e.currentTarget);
            let fileIndex: string = button.data("id"); 
            let parsedIndex = parseInt(fileIndex);
            if (parsedIndex >= 0) {
                let foundFile = this.currentDocuments[parsedIndex];
                if (foundFile) {
                    this.showSaving(true);
                    await this.removeAttachment(foundFile.id);
                    await this.updateDocuments();
                    this.showSaving(false);
                }
            }
        })
    }

    async uploadAttachments(): Promise<any> {
        // Method for uploading attachments to S3 bucket
        let formData: FormData = new FormData();
        for (let i = 0; i < this.filesToUpload.length; i++) {
            let key: string = this.currentChild.DeliverableChild.Id.toString() + "/" + this.filesToUpload[i].name;
            formData.append(key, this.filesToUpload[i]);
        }

        let result: any;       
        try {
            result = await $.ajax(this.addAttachmentsRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val(), "ParentFormId": this.currentChild.DeliverableChild.ParentId.toString(), "ChildFormId": this.currentChild.DeliverableChild.Id.toString() },
                contentType: false,
                cache: false,
                processData: false,
                data: formData
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async removeAttachment(filePath: string): Promise<any> {
        let result: any;
        try {
            result = await $.ajax(this.removeAttachmentsRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: filePath }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    public drawGallery() {
        let uploadGallery = $(`#${this.modalId}`).find(".file-upload-gallery");
        // Empty the gallery
        uploadGallery.empty();

        // Create Table in the Gallery for each file
        let galleryContent = "";

        // Add Content for Each File
        for (let i = 0; i < this.filesToUpload.length; i++) {
            let icon = this.getFileIcon(this.filesToUpload[i].type);

            galleryContent +=
                `<div class="card">
                    <div class="card-header" id="file-heading-${i}">
                        <div class="row justify-content-between">
                            <div class="col-auto">
                                <div class="header-text">
                                    <a class="text-decoration-none d-flex align-items-center">
                                        ${icon}<span class="expand-text d-block pl-2">${this.filesToUpload[i].name}</span>
                                    </a>
                                </div>
                            </div>
                            <div class="col-auto">
                                <a id="delete-file-btn-${i}" class="text-decoration-none header-delete-btn">
                                    <i class="fa-solid fa-trash"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>`
        }

        // Draw Table
        uploadGallery.append(galleryContent);


        // Add button functionality for deleting elements
        let fileUploadObj = this;

        uploadGallery.find(".header-delete-btn").on("click", function () {
            let fileId: string = $(this).prop("id");
            let index: number = parseInt(fileId.replace("delete-file-btn-", ""));
            fileUploadObj.filesToUpload.splice(index, 1);
            fileUploadObj.drawGallery();
        });

        let fileCountText = $(`#${this.modalId}`).find("#file-upload-btn-count")
        fileCountText.text(this.filesToUpload.length);

        let uploadBtnContainer = $(`#${this.modalId}`).find("#file-upload-btn-container");
        // Show Upload Button
        if (this.filesToUpload.length > 0) {
            uploadBtnContainer.removeClass("d-none");
        }
        else {
            uploadBtnContainer.addClass("d-none");
        }
    }

    showLoading(isLoading: boolean) {
        if (isLoading) {
            $(`#${this.modalId}`).find("#edit-attachments-content").addClass("d-none");
            $(`#${this.modalId}`).find("#edit-attachments-loading").removeClass("d-none");
        }
        else {
            $(`#${this.modalId}`).find("#edit-attachments-content").removeClass("d-none");
            $(`#${this.modalId}`).find("#edit-attachments-loading").addClass("d-none");
        }
    }

    showSaving(isSaving: boolean) {
        if (isSaving) {
            $(`#${this.modalId}`).find("#edit-attachments-block").addClass("d-none");
            $(`#${this.modalId}`).find("#saving-attachments-container").removeClass("d-none");
        }
        else {
            $(`#${this.modalId}`).find("#edit-attachments-block").removeClass("d-none");
            $(`#${this.modalId}`).find("#saving-attachments-container").addClass("d-none");
        }
    }

    private getFileIcon(fileType: string) {

        if (fileType.includes("image")) return `<i class="fas fa-file-image expand-btn"></i>`;
        if (fileType.includes("pdf")) return `<i class="fa-solid fa-file-pdf expand-btn"></i>`;
        if (fileType.includes("word")) return `<i class="fa-solid fa-file-word expand-btn"></i>`;
        if (fileType.includes("spreadsheet")) return `<i class="fa-solid fa-file-excel expand-btn"></i>`;
        if (fileType.includes("presentation")) return `<i class="fa-solid fa-file-powerpoint expand-btn"></i>`;
        if (fileType.includes("audio")) return `<i class="fa-solid fa-file-audio expand-btn"></i>`;
        if (fileType.includes("video")) return `<i class="fa-solid fa-file-video expand-btn"></i>`;

        return `<i class="fa-solid fa-file expand-btn"></i>`
    }
}